export default "__VITE_ASSET__14144eaa__"